<template>
  <div>
    <FocusComments v-if="hasComments" :comments="comments" />
    <p v-else :class="$style.noComments">You've not had any feedback yet</p>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import FocusComments from './FocusComments'

export default {
  components: {
    FocusComments
  },
  data () {
    return {
      comments: [],
      user: store.get('user')
    }
  },
  mounted () {
    this.retrieveFocusComments()
  },
  computed: {
    hasComments () {
      return this.comments.length > 0
    }
  },
  methods: {
    async retrieveFocusComments () {
      try {
        const response = await axios.get(`${jiminnyHost()}/api/v1/activity/comments?types[]=1&types[]=2&forUserId=${this.user.id}`)
        this.comments = response.data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style module lang="less" src="./Focus.less"></style>



// WEBPACK FOOTER //
// Focus.vue?671660f4